import { render, staticRenderFns } from "./AddAddressGHTK.vue?vue&type=template&id=1dbc1db9"
import script from "./AddAddressGHTK.vue?vue&type=script&lang=ts"
export * from "./AddAddressGHTK.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dbc1db9')) {
      api.createRecord('1dbc1db9', component.options)
    } else {
      api.reload('1dbc1db9', component.options)
    }
    module.hot.accept("./AddAddressGHTK.vue?vue&type=template&id=1dbc1db9", function () {
      api.rerender('1dbc1db9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/AddAddressGHTK.vue"
export default component.exports